export default "__VITE_ASSET__ipnljyPtpVK1lo_JJlwftw__"